import type { LoggerAdapter } from './logger-adapter.interface.js';

/**
 * Composite adapter that tries multiple adapters in order.
 * Returns the first non-null pattern found.
 */
export class CompositeAdapter implements LoggerAdapter {
  public constructor(private readonly adapters: LoggerAdapter[]) {}

  public enable(pattern?: string): void {
    for (const adapter of this.adapters) {
      adapter.enable(pattern);
    }
  }

  public disable() {
    for (const adapter of this.adapters) {
      adapter.disable();
    }
  }

  public getPattern(): string | null {
    for (const adapter of this.adapters) {
      const pattern = adapter.getPattern();
      if (pattern !== null && pattern !== '') {
        return pattern;
      }
    }

    return null;
  }
}
